// Dados das notícias
export const noticias = [
  {
    id: 103,
    title: "Acampamento Carcará 2026",
    image: "/images/acampamento_carcara_2026.jpeg",
    content:
      "Homens Fortes. Propósitos Maiores. Missão Eterna. Nos dias 21 e 22 de novembro.",
    link: "/eventos/3",
  },
  {
    id: 1,
    title: "Assistência Social",
    image: "/images/assistencia_social.jpg",
    content:
      "Ajude um irmão que está precisando de ajuda, doe alimentos, roupas ou até mesmo um pouco do seu tempo para servir a quem precisa. Além disso você pode contribuir através do pix: tescampinazonasul@verbodavida.com",
    link: `/noticias/1`,
    pixKey: "tescampinazonasul@verbodavida.com",
  },
  {
    id: 2,
    title: "Fale conosco pelo WhatsApp",
    image: "/images/fale_conosco.jpg",
    content:
      "Entre em contato conosco pelo WhatsApp para mais informações. WhatsApp: (83) 83987376137",
    link: `/noticias/2`,
  },
  {
    id: 3,
    title: "Dízimos e Ofertas",
    image: "/images/dizimos_e_ofertas.png",
    content:
      "Contribua com a obra de Deus através dos dízimos e ofertas. Sua contribuição é fundamental para o crescimento da igreja e para a realização de nossos projetos. Você pode contribuir através do pix:",
    link: `/noticias/3`,
    pixKey: "33.354.463/0001-00",
  },
];

export default noticias;
